export const SZAKJELENTESEK_DETAILS_TRANSLATIONS = {
    hu: {
        sidebar: [
            "Szak alapadatok",
            "A képzés",
            "A szak mintatanterve",
            "Tehetséges, kiemelkedő hallgatói teljesítmények",
            "Idegen nyelvi követelmények",
            "Kötelező szakmai gyakorlat",
            "Mintatanterv fejlesztések, módosítások",
            "Fejlesztési javaslatok",
            "Oktatás",
            "A szak hallgatóira vonatkozó adatok",
            "Versenytárs elemzés",
            "Meghívott előadók és óraadók",
            "Oktatók értékelése",
            "A képzés tanulmányi körülményei",
            "A szak kommunikációja",
            "Fejlesztési javaslatok megvalósítása és értékelése",
            "Szakjelentés lezárása"
        ],
        // Database keys for status checking (must match database exactly)
        statusKeys: [
            "Képzés célja",
            "Szak mintaterve",
            "Tehetséges hallgatók",
            "Idegen nyelvi követelmények",
            "Kötelező szakmai gyakorlat",
            "Mintatanterv fejlesztések, módosítások",
            "Fejlesztési javaslatok",
            "Oktatás",
            "Szak létszám adatok",
            "Versenytárs elemzés",
            "Meghívott előadók és óraadók",
            "Oktatók értékelése",
            "Tanulmányi körülmények",
            "Szak kommunikációja",
            "Fejlesztési javaslatok megvalósítása és értékelése"
        ],
        previousSection: "Előző szakasz",
        backToList: "Vissza a szakjelentés listába",
        pageTitle: "Szakjelentés lezárása",
        finalizeButton: "Lezárás és beküldés véleményezésre",
        generatePdfButton: "PDF generálás és megjelenítés",
        attachedPdfs: "Csatolt PDF-ek",
        opinions: "Vélemények",
        opinionPlaceholder: "Írja be a véleményét...",
        addOpinion: "Vélemény hozzáadása",
        sendForReview: "Beküldés vezetői véleményezésre",
        pdfModalTitle: "PDF Generálás Piszkozat",
        save: "Mentés",
        close: "Bezárás",
        alertFinalized: "A teljes szakjelentés lezárva.",
        alertOpinion: "Szakjelentés elküldve vezetői véleményezésre.",
        ok: "OK",
        confirmMessage: "Biztosan le akarja zárni a szakjelentést és beküldeni véleményezésre?",
        confirmCancel: "Vissza",
        confirmYes: "Igen"
    },
    en: {
        sidebar: [
            "Programme Basic Data",
            "The Programme",
            "Programme Curriculum",
            "Talented Students and Outstanding Student Performance",
            "Foreign Language Requirements",
            "Compulsory Professional Practice",
            "Curriculum Developments and Modifications",
            "Development Recommendations",
            "Teaching",
            "Data related to the major",
            "Competitor Analysis",
            "Guest Lecturers and Part-time Teachers",
            "Assessment of Teachers",
            "Study Conditions",
            "Programme Communication",
            "Implementation and Evaluation of Development Recommendations",
            "Finalisation of Programme Report"
        ],
        previousSection: "Previous Section",
        backToList: "Back to Programme Reports List",
        pageTitle: "Finalisation of Programme Report",
        finalizeButton: "Finalise and send for Management Review",
        generatePdfButton: "Generate and Display PDF",
        attachedPdfs: "Attached PDFs",
        opinions: "Opinions",
        opinionPlaceholder: "Enter your opinion...",
        addOpinion: "Add Opinion",
        sendForReview: "Send for Management Review",
        pdfModalTitle: "PDF Generation Preview",
        save: "Save",
        close: "Close",
        alertFinalized: "The complete programme report has been finalised.",
        alertOpinion: "Programme report sent for management review.",
        ok: "OK",
        confirmMessage: "Are you sure you want to finalize the programme report and send it for review?",
        confirmCancel: "Cancel",
        confirmYes: "Confirm"
    }
};